import { Icon } from '@iconify/react'
import { getCampaignEditorGroup, getCampaignEditorTab } from './campaignEditorNavigation'
import styles from './CampaignEditor.module.css'
import { campaignEditorHelp } from './campaignEditorHelp'

export function CampaignEditorSectionHeader({
  tab,
  templateName,
}: {
  tab: string
  templateName: string
}) {
  const group = getCampaignEditorGroup(tab)
  const section = getCampaignEditorTab(tab)
  const help = campaignEditorHelp[section.id]
  return (
    <header className={styles.sectionHeader}>
      <div className={styles.sectionHeading}>
        <span className={styles.sectionIcon}>
          <Icon icon={group.icon} aria-hidden />
        </span>
        <div>
          <h2>{group.title}</h2>
          <p>{group.description}</p>
        </div>
        {group.id === 'page' && (
          <span className={styles.templateBadge}>{templateName}</span>
        )}
      </div>
      {section.help && (
        <div className={styles.sectionHelp}>
          <div className={styles.guideIntro}>
            <p>{section.help}</p>
            <span className={styles.requirement}>{help.requirement}</span>
          </div>
          <details key={section.id} className={styles.helpDetails}>
            <summary>
              <Icon icon="mdi:lightbulb-outline" aria-hidden /> Dicas para preencher esta
              aba <Icon icon="mdi:chevron-down" aria-hidden />
            </summary>
            <ul>
              {help.tips.map((tip) => (
                <li key={tip}>{tip}</li>
              ))}
            </ul>
          </details>
        </div>
      )}
    </header>
  )
}
